import React from 'react';
import { Facebook, Phone, Mail } from 'lucide-react';
const PHONE = '586-203-3701';
const EMAIL = 'MoceriRS@gmail.com';
export function TopBar() {
  return <div className="w-full bg-[#3a3a3a] text-white text-sm" data-id="element-339">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center justify-between gap-2" data-id="element-340">
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-341">
          <Facebook className="w-4 h-4 text-[#2DB8E0]" data-id="element-342" />
          <span className="font-medium" data-id="element-343">Follow Us On FB</span>
        </a>
        <div className="flex items-center gap-6" data-id="element-344">
          <a href={`tel:${PHONE.replace(/-/g, '')}`} className="hidden sm:flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-345">
            <Phone className="w-4 h-4 text-[#2DB8E0]" data-id="element-346" />
            <span className="font-medium" data-id="element-347">{PHONE}</span>
          </a>
          <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-[#2DB8E0] transition-colors" data-id="element-348">
            <Mail className="w-4 h-4 text-[#2DB8E0]" data-id="element-349" />
            <span className="font-medium" data-id="element-350">{EMAIL}</span>
          </a>
        </div>
      </div>
    </div>;
}